/**
 * NX-4971 — advisory payslip-verifier column helper.
 *
 * Shared by the draft-payroll factories in `columns.tsx` AND the inline column
 * array in `dashboard/components/ConfirmPayroll.tsx` (which do not share otherwise).
 * Kept in its own module so `PayslipVerdictBadge.tsx` only exports components.
 */
import { TypedMessages } from '@nxsys/hooks/useTypedIntl';
import { DraftPayroll } from '@nxsys/types/models/payroll';
import { ColumnsType } from 'antd/es/table';
import { PayslipVerdictBadge } from './PayslipVerdictBadge';

/**
 * Column definition for the advisory verifier badge. Kept `fixed: 'left'` so it
 * stays next to the actions column while the wide payroll table scrolls.
 */
export const verifierColumn = (
  _messages: TypedMessages,
  onView?: (record: DraftPayroll) => void,
): ColumnsType<DraftPayroll>[number] => ({
  key: 'payslipVerification',
  title: 'Verifier',
  align: 'center',
  width: 200,
  fixed: 'left',
  render: (record: DraftPayroll) => (
    <PayslipVerdictBadge
      verification={record?.payslipVerificationRef}
      onClick={onView ? () => onView(record) : undefined}
    />
  ),
});
